import { ReactComponent as AmazonLogo } from "../../../assets/icons/amazon_logo.svg";

const AmazonReferralBanner = () => {
  return (
    <div className="w-full flex justify-center items-center px-2">
      {/* Outer border + glow */}
      <div
        className="
          w-full
          rounded-[12px]
          p-[1px]
          bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.4)_0,rgba(255,255,255,0)_60%)]
          shadow-[0_0_0_1px_rgba(255,255,255,0.25),0_18px_40px_rgba(0,0,0,0.7)]
        "
      >
        {/* Inner pill */}
        <div
          className="
            flex flex-col md:flex-row
            items-center md:items-center
            justify-between
            gap-2 sm:gap-3 md:gap-4
            rounded-[12px]
            px-3 py-3 sm:px-4 sm:py-3 md:px-8 md:py-4
            bg-[linear-gradient(90deg,#071727_0%,#072c4a_50%,#020b18_100%)]
          "
        >
          {/* Text */}
          <p
            className="
              text-[13px] sm:text-[15px] md:text-[24px]
              text-white
              text-center md:text-left
              leading-snug sm:leading-snug md:leading-tight
            "
          >
            Give{" "}
            <span className="text-[15px] sm:text-[18px] md:text-[32px] text-[#FF9D1B] font-semibold">
              5 references
            </span>{" "}
            &amp; get{" "}
            <span className="text-[15px] sm:text-[18px] md:text-[32px] text-[#FF9D1B] font-semibold">
              $100
            </span>{" "}
            Amazon Voucher after verification.
          </p>

          {/* Logo */}
          <div className="flex items-center justify-center flex-shrink-0 mt-1 md:mt-0">
            <AmazonLogo className="h-5 sm:h-6 md:h-8 w-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonReferralBanner;
